import AddIcons from '@/icons/AddIcons'
import BriefCaseIcons from '@/icons/BriefCaseIcons'
import ContractIcons from '@/icons/ContractIcons'
import ServiceTrialIcons from '@/icons/ServiceTrialIcons'
import { useTranslation } from 'react-i18next'
import { StepActionsProps } from './types'

const StepActions = ({
    stepValue,
    isLocked,
    hasContractCompleted,
    onAddNote,
    onCreateBusinessTrip,
    onCreateMeetingOnline,
    onCreatePOC,
    onAddNegotiation,
    onCreateContract,
}: StepActionsProps) => {
    const { t } = useTranslation()

    return (
        <div className="p-2 border-t border-gray-100 space-y-1">
            {/* Add Note */}
            <button
                className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                    !isLocked
                        ? 'text-gray-600 hover:bg-gray-100'
                        : 'text-gray-300 cursor-not-allowed'
                }`}
                onClick={() => !isLocked && onAddNote(stepValue)}
                disabled={isLocked}
                data-tour="add-note-btn"
            >
                <AddIcons className="w-3 h-3" />
                {t('add-note')}
            </button>

            {/* Presentation Step - Create Business Trip & Meeting Online */}
            {stepValue === 'presentation' && (
                <>
                    <button
                        className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                            !isLocked
                                ? 'bg-blue-500 text-white hover:bg-blue-600'
                                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        }`}
                        onClick={onCreateBusinessTrip}
                        disabled={isLocked}
                        data-tour="create-business-trip-btn"
                    >
                        <BriefCaseIcons className="w-3 h-3" />
                        {t('create-business-trip')}
                    </button>
                    <button
                        className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                            !isLocked
                                ? 'border border-violet-300 text-violet-700 hover:bg-violet-50'
                                : 'border border-gray-200 text-gray-400 cursor-not-allowed'
                        }`}
                        onClick={onCreateMeetingOnline}
                        disabled={isLocked}
                        data-tour="create-meeting-btn"
                    >
                        <svg
                            className="w-3 h-3"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                            />
                        </svg>
                        {t('meeting-online')}
                    </button>
                </>
            )}

            {/* POC Step - Create POC */}
            {stepValue === 'poc' && (
                <button
                    className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                        !isLocked
                            ? 'bg-amber-500 text-white hover:bg-amber-600'
                            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    }`}
                    onClick={onCreatePOC}
                    disabled={isLocked}
                    data-tour="create-poc-btn"
                >
                    <ServiceTrialIcons className="w-3 h-3" />
                    {t('create-poc')}
                </button>
            )}

            <button
                className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                    !isLocked
                        ? 'border border-emerald-300 text-emerald-700 hover:bg-emerald-50'
                        : 'border border-gray-200 text-gray-400 cursor-not-allowed'
                }`}
                onClick={() => !isLocked && onAddNegotiation(stepValue)}
                disabled={isLocked}
                data-tour="add-negotiation-btn"
            >
                <AddIcons className="w-3 h-3" />
                {t('add-negotiation')}
            </button>

            {/* Contract Step - Contract */}
            {stepValue === 'contract' && !hasContractCompleted && (
                <button
                    className={`w-full px-2 py-1.5 text-xs rounded flex items-center justify-center gap-1 ${
                        !isLocked
                            ? 'bg-emerald-600 text-white hover:bg-emerald-700'
                            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    }`}
                    onClick={onCreateContract}
                    disabled={isLocked}
                    data-tour="create-contract-btn"
                >
                    <ContractIcons className="w-3 h-3" />
                    {t('create-contract')}
                </button>
            )}
        </div>
    )
}

export default StepActions
